import { Controller } from 'stimulus';
// @ts-ignore
import EventBus from 'eventbusjs';

export class EventController extends Controller {
  _eventListeners: { event: string; callback: any }[] = [];

  addEventListener(event: string, callback: any) {
    this._eventListeners.push({ event, callback });
    EventBus.addEventListener(event, callback, this);
  }

  dispatch(event: string, ...args: any) {
    EventBus.dispatch(event, this, ...args);
  }

  dispatchNextTick(event: string, ...args: any) {
    setTimeout(() => this.dispatch(event, ...args), 1);
  }

  disconnect() {
    this._eventListeners.forEach(({ event, callback }) => {
      EventBus.removeEventListener(event, callback);
      this._eventListeners = [];
    });
  }
}

export class RenderController extends EventController {
  // A controller with setState() and render(), simulating a React component

  state = {};

  setState(newState: any) {
    this.state = { ...this.state, ...newState };
    this.render();
  }

  // overwrite me!
  render() {
    throw Error('Overwrite the render() method to use setState()');
  }
}
